<template>
  <span>
    <v-menu top :max-height="300">
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          flat
          :disabled="!keywords.length"
          :loading="loading > 0"
          v-on="on"
        >
          Add To My Ptoject
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(project, index) in projects"
          :key="index"
          @click="saveKeywords(project)"
        >
          <v-list-tile-title>{{ project.text }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
export default {
  name: 'AddKeywordsToProjectBtn',
  props: ['keywords'],
  data () {
    return {
      isAdmin: this.$store.state.user.permissions.is_admin,
      loading: 0,
      projects: []
    }
  },
  mounted () {
    this.getProjects()
  },
  methods: {
    saveKeywords (project) {
      if (this.checkPermissions(this.keywords.length, project.engines)) {
        let params = {
          projectId: project.id,
          keywords: this.keywords
        }
        this.loading = true
        this.$store.dispatch('ADD_KEYWORDS', params).then(res => {
          this.$toasted.show(`${this.keywords.length * project.engines.length} keywords were successfully added to project for ${project.engines.length} search engines`, { duration: 10000 })
          this.loading = false
          this.$eventEmitter.$emit('clearSelectedKeywords')
          this.$store.dispatch('GET_USER_DATA')
        }, err => {
          console.log('ADD_KEYWORDS error', err)
          this.loading = false
          let errorText = this.$services.getApiError(err)
          if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
        })
      }
    },
    checkPermissions (keywordsCount, engines) {
      let remainedKeywordsCount = this.$store.state.user.keywords_limit - this.$store.state.user.keywords_count
      let addKeywordsCount = engines.length * keywordsCount
      if (!this.isAdmin && addKeywordsCount > remainedKeywordsCount) {
        let alertTextHTML = `אתה מנסה להוסיף ` +
          `<span class="font-weight-bold" title="${engines.length}(search engine(s)) * ${keywordsCount}(keywords)">${addKeywordsCount}</span>` +
          ` מילים אבל נשארו לך <span class="font-weight-bold" title="${this.$store.state.user.keywords_limit}(package limit) - ${this.$store.state.user.keywords_count}(exist keywords)">${remainedKeywordsCount}</span> מילים לניצול.` +
          `<br/>אתה יכול לשדרג חבילה או לנסות את מערכת כליום`

        this.$eventEmitter.$emit('showAlert', 'perms', 'אתה חורג מכמות המילים לחבילה', alertTextHTML)
        return false
      }
      return true
    },
    getProjects () {
      this.loading = true
      let params = {
        load_extra_data: false,
        page: 1,
        count: 100,
        order_by: 'created',
        direction: 'desc',
        filter_blocks: [{
          operator: 'and',
          filters: [
            {
              column: 'owner',
              operator: '~',
              value: this.$store.state.user.email
            }
          ]
        }]
      }
      this.$store.dispatch('PROJECTS', params).then(res => {
        res.data.map((project) => {
          this.projects.push({ text: project.name, id: project.id, engines: project.engines })
        })
        this.loading = false
      }, err => {
        this.loading = false
        console.log('PROJECTS ERROR', err)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/keywords/AddKeywordsToProjectBtn.vue